import React, { useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';

// queries
import { useMutation } from '@apollo/client';
import { REPLACE_CREW_MEMBER_ON_ASSIGNMENT } from '../../../graphql/crewMemberAssignment/crewMemberAssignment.mutations';

// components
import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component';

// collections
import ReplaceCrewMemberForm from './forms/ReplaceCrewMember.form';

// utils
import { validate } from '../../../shared/utility';

// mui
import { Grid, Container, Typography } from '@mui/material';

const validationSchema = {
    assignment: {
        type: "input",
        validation: {
            required: true
        }
    },
    newCrewMember: {
        type: "input",
        validation: {
            required: true
        }
    }
}

export default function ReplaceCrewMember() {
    const history = useHistory()
    const { jobDayId } = useParams()
    const parsedJobDayId = parseInt(jobDayId)
    const currentForm = useRef()
    const [replaceCrewMemberOnAssignment] = useMutation(REPLACE_CREW_MEMBER_ON_ASSIGNMENT)
    const [errors, setErrors] = useState({})

    const handleSubmit = () => {
        if(currentForm.current && currentForm.current.getData) {
            const finalData = currentForm.current.getData()
            const { isValid, errors } = validate(finalData, validationSchema)

            if(isValid) {
                replaceCrewMemberOnAssignment({ variables: {...finalData}, refetchQueries: []})
                .catch(e => {
                    console.error(e)
                }).then(result => {
                    if(result) {
                        history.push(`/schedule/details/${jobDayId}`)
                    }
                })
            } else {
                setErrors(errors)
            }
        }
    }

    return (<div>
        <Container disableGutters sx={{ marginBottom: 4 }}>
            <Grid container>
                <Grid item><Typography variant="h2">Replace Crew Member</Typography></Grid>
            </Grid>
        </Container>  

        <ReplaceCrewMemberForm jobDayId={parsedJobDayId} ref={currentForm} errors={errors} />

        <Container disableGutters sx={{ marginBottom: 4, marginTop: 4 }}>
            <Grid container spacing={2}>
                <Grid item><ActionButton label='Cancel' color='secondary' onClick={() => history.goBack()} /></Grid>
                <Grid item><ActionButton label='Save Changes' color='success' onClick={handleSubmit} /></Grid>
            </Grid>
        </Container>
    </div>)
}